document.addEventListener("DOMContentLoaded", () => {
  // Nur für Mobile
  if (window.innerWidth >= 768) return;

  // Ab wann das kleine Fenster erscheint: Anteil der Galerie, der oben schon
  // rausgescrollt ist. 0.4 = 40 %. Kleiner = früher, größer = später.
  const AUSGESCROLLT_AB = 0.4;

  const start = (galleryWrapper, galleryContent) => {
    // 1. CSS für das schwebende Fenster (unverändert)
    const style = document.createElement("style");
    style.textContent = `
      body.tee-is-sticky .tee-gallery-content {
        position: fixed !important;
        top: 80px !important;
        right: 15px !important;
        left: auto !important;
        width: 40vw !important;
        height: 40vw !important;
        z-index: 99999 !important;
        background: #ffffff !important;
        border-radius: 8px !important;
        box-shadow: 0 4px 15px rgba(0,0,0,0.2) !important;
        padding: 5px !important;
      }
      body.tee-is-sticky .tee-gallery-content .tee-gallery,
      body.tee-is-sticky .tee-gallery-content .tee-slider,
      body.tee-is-sticky .tee-gallery-content .tee-slider__inner,
      body.tee-is-sticky .tee-gallery-content .tee-slide {
        width: 100% !important;
        height: 100% !important;
        min-height: 0 !important;
        transform: none !important;
      }
      body.tee-is-sticky .tee-gallery-content canvas,
      body.tee-is-sticky .tee-gallery-content img {
        width: 100% !important;
        height: 100% !important;
        max-width: 100% !important;
        object-fit: contain !important;
      }
      body.tee-is-sticky .tee-gallery-content .tee-slider__dots,
      body.tee-is-sticky .tee-gallery-content .tee-thumbnails,
      body.tee-is-sticky .tee-gallery-content button {
        display: none !important;
      }
      /* Galerie-Ebene über Teeinblue-Formular (2) und Produktkarten (1), unter Header (4) */
      body.tee-is-sticky .product-information__media media-gallery {
        z-index: 3 !important;
      }
    `;
    document.head.appendChild(style);

    // 2. Umschalten zwischen groß und klein
    const setSticky = (an) => {
      const istAn = document.body.classList.contains("tee-is-sticky");
      if (an && !istAn) {
        // Platz reservieren, damit die Eingabefelder nicht nach oben springen
        galleryWrapper.style.height = galleryWrapper.offsetHeight + "px";
        document.body.classList.add("tee-is-sticky");
      } else if (!an && istAn) {
        document.body.classList.remove("tee-is-sticky");
        galleryWrapper.style.height = "";
        // teeinblue neu messen lassen: Hat sich die Fenstergröße geändert,
        // während das Fenster klein war (Adressleiste am Handy), hat teeinblue
        // sich die kleine Größe gemerkt. Ein Resize-Signal setzt das zurück.
        requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
      }
    };

    // 3. Bei jedem Bildschirm-Frame während des Scrollens prüfen, wo das Bild
    //    steht. Gemessen wird das Bild selbst, nicht der ganze Galerie-Bereich,
    //    damit Thumbnails oder andere Elemente darunter den Auslöser nicht
    //    verzögern.
    //    Runter: klein ab AUSGESCROLLT_AB. Hoch: groß, sobald der Platz des
    //    Bildes sichtbar ist und wirklich hochgescrollt wird.
    //    Toleranzen gegen Zittern beim langsamen Scrollen am Handy: Ein, zwei
    //    Pixel Rückwärtsbewegung schalten nicht um.
    const UMKEHR_HOCH = 40;   // so viele px nach oben, bis es als "Hochscrollen" zählt
    const UMKEHR_RUNTER = 20; // so viele px nach unten, bis es wieder als "Runterscrollen" zählt
    const PUFFER = 40;        // px Abstand zur Schwelle beim Zurückschalten
    let bildOffset = 0; // Abstand Oberkante Galerie-Bereich -> Oberkante Bild
    let bildHoehe = 0;  // Höhe des großen Bildes
    let richtung = "runter";
    let umkehrPunkt = window.scrollY; // tiefster bzw. höchster Punkt in der aktuellen Richtung
    let wartet = false;

    const bildMessen = () => {
      // Nur im großen Zustand messen; im kleinen Fenster ist das Bild verkleinert.
      if (document.body.classList.contains("tee-is-sticky")) return;
      const bild =
        galleryWrapper.querySelector(".tee-gallery-content .tee-slider") ||
        galleryWrapper.querySelector(".tee-gallery-content");
      if (!bild) return;
      const b = bild.getBoundingClientRect();
      if (b.height < 50) return; // teeinblue baut die Vorschau noch auf
      bildOffset = b.top - galleryWrapper.getBoundingClientRect().top;
      bildHoehe = b.height;
    };

    const pruefen = () => {
      wartet = false;
      bildMessen();
      if (!bildHoehe) return;

      // Scrollrichtung mit Toleranz: Kleines Zittern zählt nicht als Umkehr.
      const scrollPos = window.scrollY;
      if (richtung === "runter") {
        if (scrollPos > umkehrPunkt) umkehrPunkt = scrollPos;
        else if (umkehrPunkt - scrollPos >= UMKEHR_HOCH) {
          richtung = "hoch";
          umkehrPunkt = scrollPos;
        }
      } else {
        if (scrollPos < umkehrPunkt) umkehrPunkt = scrollPos;
        else if (scrollPos - umkehrPunkt >= UMKEHR_RUNTER) {
          richtung = "runter";
          umkehrPunkt = scrollPos;
        }
      }

      // Der Galerie-Bereich bleibt im kleinen Zustand mit fester Höhe stehen,
      // daher lässt sich die Position des (großen) Bildes jederzeit berechnen.
      const bildOben = galleryWrapper.getBoundingClientRect().top + bildOffset;
      const bildUnten = bildOben + bildHoehe;
      const schwelle = -bildHoehe * AUSGESCROLLT_AB;
      const platzSichtbar = bildUnten > 0;

      if (!document.body.classList.contains("tee-is-sticky")) {
        // klein werden: beim Runterscrollen ab der Schwelle,
        // oder wenn das Bild komplett weg ist (z. B. nach einem Sprung)
        if ((richtung === "runter" && bildOben < schwelle) || !platzSichtbar) {
          setSticky(true);
        }
      } else {
        // groß werden: beim Hochscrollen, sobald der Platz sichtbar ist,
        // oder wenn man wieder deutlich über der Schwelle ist (z. B. Sprung nach oben)
        if ((richtung === "hoch" && platzSichtbar) || bildOben > schwelle + PUFFER) {
          setSticky(false);
        }
      }
    };

    // Höchstens einmal pro Frame prüfen (flüssig, auch beim schnellen Wischen)
    const anstossen = () => {
      if (!wartet) {
        wartet = true;
        requestAnimationFrame(pruefen);
      }
    };
    window.addEventListener("scroll", anstossen, { passive: true });
    window.addEventListener("resize", anstossen, { passive: true });
    pruefen();
  };

  // 4. Warten, bis teeinblue die Galerie gebaut hat (statt fest 2 Sekunden)
  const finde = () => {
    const w = document.querySelector(".product-information__media");
    const c = document.querySelector(".product-information__media .tee-gallery-content");
    return w && c ? [w, c] : null;
  };
  const gefunden = finde();
  if (gefunden) return start(...gefunden);

  const beobachter = new MutationObserver(() => {
    const f = finde();
    if (f) { beobachter.disconnect(); start(...f); }
  });
  beobachter.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => beobachter.disconnect(), 20000); // nach 20 s aufgeben
});